import { promisify } from "../utils/promises";
export default {
    getAccessToken: promisify(() => window.opr.operaIdentityPrivate.getAccessToken),
    getUserData: promisify(() => window.opr.operaIdentityPrivate.getUserData),
    startTabAuth: promisify(() => window.opr.operaIdentityPrivate.startTabAuth),
    getLoggedInState: promisify(() => window.opr.operaIdentityPrivate.getLoggedInState),
    addListener(handler) {
        window.opr.operaIdentityPrivate.onLoginStateChange.addListener(handler);
    },
    removeListener(handler) {
        window.opr.operaIdentityPrivate.onLoginStateChange.removeListener(handler);
    },
};
